import firebase from 'firebase/app'
import fireb from '../firebase/fireBase';
import configureStore from '../store/configureStore';
import { setSelectedApp } from './appVarious';
import { getFingerprint } from './utils';
import { staticQuery } from './handleDb';

const db = fireb.firestore()

const createApp = async (data, applist, uid, appid) => {

  let newData = {
    ...data,
    appid,
    headerlogo: '',
    headerlogofile: '',
    created: firebase.firestore.FieldValue.serverTimestamp(),
    changes: false,
  }

  let appRef = db.collection("apps").doc(appid);

  return await appRef.update(newData)
    .then(() => {

      if (applist.length > 1) {
        setSelectedApp(applist, appid, uid)
      }

      return newData
    })
    .catch(error => console.error("Error ", error))
}

const setAppConfig = appData => {

  // restoreAppPreview(appData.appid, appData)

  configureStore.dispatch({
    type: 'CLEAR_APP_CONFIG',
  })

  configureStore.dispatch({
    type: 'CHANGE_APP_CONFIG',
    payload: {
      ...appData
    }
  })

  return true
}


const uniquePreviewId = async (appid) => {

  const batch = db.batch()
  let previewId

  await getFingerprint()
    .then(pi => {
      previewId = pi
      return staticQuery(
        `appsPreview`,
        [{
          field: 'previewId',
          operator: '==',
          value: pi
        }]
      )
    })
    .then(data => data.forEach(d => {
      batch.update(
        db.collection('appsPreview').doc(d.appid)
        , { previewId: '' }
      )
    }))

  batch.update(
    db.collection('appsPreview').doc(appid)
    , { previewId: previewId }
  )

  return batch.commit()
}

const getAppConfig = async (uid) => {
  let authApp, query = db.collection('apps'), previewId

  // Traemos las posibles apps asignadas
  await db.collection(`users`)
    .doc(uid)
    .get()
    .then(data => {
      if (!data.data()) {
        return null
      }
      authApp = data.data().selectedApp
    })

  if (authApp) {
    query = query.where('appid', '==', authApp)
  } else {
    query = query.where('ownerid', '==', uid)
    query = query.where('selected', '==', true)
  }

  //Terminar esta logica y seguir con los permisos

  // configureStore.dispatch({
  //   type: 'CLEAR_APP_CONFIG',
  // })

  await getFingerprint()
    .then(fp => previewId = fp)

  return await query.get()
    .then(res => {
      if (res.empty) {
        return false
      } else {
        let newData, appid

        res.forEach(d => {
          newData = d.data()
          appid = d.id
        })

        // restoreAppPreview(newData.appid, newData)

        newData.previewId = previewId
        newData.appid = appid
        newData.id = appid
        uniquePreviewId(appid)

        configureStore.dispatch({
          type: 'SET_APP_CONFIG',
          payload: {
            ...newData,
          }
        })

        return
      }
    })

}

const sendAppConfig = async (appid, appdata) => {
  const Ref = db.collection('apps').doc(appid)

  delete appdata.created

  await Ref.update({
    updated: firebase.firestore.FieldValue.serverTimestamp(),
    ...appdata,
    changes: false
  })

  return configureStore.dispatch({
    type: 'SET_APP_CONFIG',
    payload: {
      ...appdata,
      changes: false
    }
  })
}

const updateAppConfig = (appid, appdata) => {
  let Ref = db.collection('apps').doc(appid)
  Ref.update({
    ...appdata
  })

  return configureStore.dispatch({
    type: 'SET_APP_CONFIG',
    payload: {
      ...appdata,
    }
  })
}

export {
  createApp,
  getAppConfig,
  setAppConfig,
  uniquePreviewId,
  sendAppConfig,
  updateAppConfig
}